import React from 'react';
import classNames from 'classnames';
import { Tag, Text } from '@ui';
import { formatDate, formatDateTime, formatTime } from './format';
import { changeSummary, missingPlatformText, pendingNote, platformPillTag, railsDecisionTag, t } from './labels';
function Empty({ children }) {
    return (React.createElement(Text, { variant: "xx-small", className: "push-history__empty" }, children));
}
export function WhenCell({ row, timeZone, expanded }) {
    return (React.createElement("span", { className: "push-history__when", "data-row-kind": row.kind },
        React.createElement("i", { className: classNames('fa-light', expanded ? 'fa-chevron-down' : 'fa-chevron-right'), "aria-hidden": "true" }),
        React.createElement(Text, { variant: "body" }, formatTime(row.at, timeZone)),
        React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, formatDate(row.at, timeZone))));
}
export function RailsDecisionCell({ row }) {
    const tag = railsDecisionTag(row);
    if (!tag)
        return React.createElement(Empty, null, t('missing_rails'));
    return React.createElement(Tag, { label: tag.label, variant: tag.variant, colorStyle: "pastry", readOnly: true });
}
export function WhatChangedCell({ row, timeZone }) {
    var _a;
    if (row.events.length === 0)
        return null;
    const note = (_a = pendingNote(row, timeZone)) !== null && _a !== void 0 ? _a : t('events_count', { count: row.events.length });
    const summary = changeSummary(row);
    return (React.createElement("span", { className: "push-history__ellipsis", title: summary },
        React.createElement(Text, { variant: "body" }, summary),
        ' ',
        React.createElement(Text, { variant: "xx-small", className: "push-history__muted" },
            "\u00B7 ",
            note)));
}
export function JoinCell({ row }) {
    var _a;
    const linked = row.kind === 'both';
    const label = (_a = row.notificationId) !== null && _a !== void 0 ? _a : (row.railsOutcome === 'published' ? t('join.no_id') : '—');
    return (React.createElement("span", { className: classNames('push-history__join', linked && 'push-history__join--linked') },
        React.createElement("code", { className: "push-history__chip" }, label)));
}
export function PlatformStatusCell({ row, platformUnavailable }) {
    if (!row.platform)
        return React.createElement(Empty, null, missingPlatformText(row, platformUnavailable));
    const tag = platformPillTag(row.platform);
    return (React.createElement("span", { className: "push-history__status" },
        React.createElement(Tag, { label: tag.label, variant: tag.variant, colorStyle: "pastry", readOnly: true }),
        row.platform.failureReason && React.createElement("code", { className: "push-history__reason" }, row.platform.failureReason)));
}
export function PlatformTitleCell({ row }) {
    var _a;
    if (!((_a = row.platform) === null || _a === void 0 ? void 0 : _a.title))
        return null;
    return (React.createElement("span", { className: "push-history__ellipsis", title: row.platform.title },
        React.createElement(Text, { variant: "body", className: "push-history__muted" }, row.platform.title)));
}
export function QueuedAtCell({ row, timeZone }) {
    if (!row.platform)
        return null;
    return React.createElement(Text, { variant: "xx-small" }, formatDateTime(row.platform.createdAt, timeZone));
}
export function DispatchedAtCell({ row, timeZone }) {
    if (!row.platform)
        return null;
    return React.createElement(Text, { variant: "xx-small" }, formatDateTime(row.platform.dispatchedAt, timeZone));
}
export function PlatformReceivedCell({ row, timeZone }) {
    var _a;
    if (((_a = row.platform) === null || _a === void 0 ? void 0 : _a.status) !== 'dispatched')
        return null;
    const { confirmedAt, replayCount } = row.platform;
    return (React.createElement("span", { className: "push-history__received" },
        confirmedAt ? (React.createElement(Text, { variant: "xx-small" }, formatDateTime(confirmedAt, timeZone))) : (React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, t('received.not_confirmed'))),
        replayCount > 0 && (React.createElement(Text, { variant: "xx-small", className: "push-history__muted push-history__replays" }, t('received.replayed', { count: replayCount })))));
}
